export const URL_AnamnesisClient = (`${process.env.REACT_APP_HOST}/AnamnesisClient`)
export const URL_AnamnesisSheets = (`${process.env.REACT_APP_HOST}/AnamnesisSheets`)
export const URL_AnamnesisGroup = (`${process.env.REACT_APP_HOST}/AnamnesisGroup`)
export const URL_Anamnesis = (`${process.env.REACT_APP_HOST}/Anamnesis`)
export const URL_AnamnesisListOptions = (`${process.env.REACT_APP_HOST}/AnamnesisListOptions`)